import { ActivatedRoute } from "@angular/router";
import { isNumber as IsNumber } from "lodash";

export function SpreadIfDefined(obj: any): any {
  return Object.entries(obj)
    .filter(([_, value]) => value !== undefined)
    .reduce((result, [key, value]) => ({ ...result, [key]: value }), {});
}

export const isObject = (object) => {
  return object != null && typeof object === "object";
}

export function capitalizeFirstLetter(str) {
  if (!str) return str; // Return the original string if it's empty

  str = str.charAt(0).toUpperCase() + str.slice(1);
  return str;
}

export function isNumeric(value) {
  return IsNumber(value);
}

export const convertUniqueIdToTankId = (uniqueId: number): number => {
  //remove the last 1 digit from the uniqueId to get the tankId
  return Math.floor(uniqueId / 10);
}

export const getActiveRoutes = (
  route: ActivatedRoute,
): ActivatedRoute[] => {
  const routes: ActivatedRoute[] = [];

  // Traverse over the state tree and populate the routes array
  const traverseRoutes = (activatedRoutes: ActivatedRoute) => {
    if (activatedRoutes && activatedRoutes.firstChild) {
      routes.push(activatedRoutes.firstChild);
      traverseRoutes(activatedRoutes.firstChild);
    }
  };

  traverseRoutes(route);

  return routes;
}

export const generateCopiedProfileName = (profileName: string, existingNames: Array<string>) => {
  if(!existingNames || existingNames.length === 0) 
    return profileName;
  
  let baseName = profileName;
  const copyRegex = /\s+-\s+Copy(?:\s+\((\d+)\))?$/;
  const match = profileName.match(copyRegex);
  
  if (match) {
    baseName = profileName.substring(0, match.index);
  }
  
  // Find all existing copies to determine next number
  const copyPattern = new RegExp(`^${baseName}\\s+-\\s+Copy(?:\\s+\\((\\d+)\\))?$`);
  const copyNumbers = existingNames
    .map(name => {
      const match = name.match(copyPattern);
      return match ? (match[1] ? parseInt(match[1]) : 0) : 0;
    })
    .filter(num => num > 0)
    .sort((a, b) => a - b); // Sort numbers in ascending order

  // Check if there are any copies
  if (copyNumbers.length === 0) {
    // No copies exist yet
    return `${baseName} - Copy (1)`;
  }
  
  // Find the first gap in the sequence starting from 1
  let sequence = [...copyNumbers];
  
  for (let i = 1; i <= sequence.length + 1; i++) {
    if (!sequence.includes(i)) {
      return `${baseName} - Copy (${i})`;
    }
  }
  
  // If we get here, there are no gaps, so use the next number
  return `${baseName} - Copy (${sequence.length + 1})`;
}


